import { FontSizes } from '@fluentui/react';

import type { IH2OTheme } from '../../../../models/components.models';
import { FontWeights } from '../../../../themes/styles';
import { mediaMobile } from '../../../../utils/styles';
import type { MainNavigationSectionStyles } from './types';

export const navigationBlocksStyles = (_theme: IH2OTheme): MainNavigationSectionStyles => ({
  root: {},
  block: {
    padding: '18px 0',
  },
  title: {
    padding: '0 16px',
    fontWeight: FontWeights.semiBold,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    transition: 'transform .2s, opacity .2s',
    '& + ul .element-wrapper': { padding: 8 },
    ...mediaMobile({
      fontSize: FontSizes.mediumPlus,
      lineHeight: FontSizes.large,
    }),
  },
  titleLink: {
    // The block title is a normal nav link; only the weight distinguishes it from its children.
    // No chevron here — in this nav a chevron means the item opens a sub-nav.
    selectors: {
      '.element-wrapper': { fontWeight: FontWeights.semiBold },
      // General sibling, not adjacent: `subText` can sit between the link and the list.
      '& ~ ul .element-wrapper': { padding: 8 },
    },
  },
  subText: {
    padding: '0 16px 4px',
    color: _theme.semanticColors?.textSecondary,
    fontSize: FontSizes.small,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  blockHeader: {
    display: 'flex',
    margin: '-8px 0 8px',
    paddingRight: 16,
  },
});
